import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
// material
import {
  Box,
  Typography,
  Card,
  Button,
  List,
  ListItem,
  Grid,
  CardContent,
  Avatar,
  Stack,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { config } from "../../core/service/config.service";
import { useNavigate } from "react-router-dom";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        p: 1,
        m: 1,
        borderRadius: 2,
        fontSize: "0.875rem",
        fontWeight: "700",
        bgcolor: (theme) =>
          theme.palette.mode === "dark" ? "#101010" : "grey.100",
        // color: (theme) =>
        //   theme.palette.mode === "dark" ? "grey.300" : "grey.800",
        border: "1px solid",
        borderColor: (theme) =>
          theme.palette.mode === "dark" ? "grey.800" : "grey.300",
        borderRadius: 2,
        fontSize: "0.875rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

ProfileView.propTypes = {
  user: PropTypes.object,
  anotherUser: PropTypes.object,
};

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const AnotherProfile = (user) => {
  const {
    fellow,
    mentor_information,
    postdoctoral_information,
    email,
    personal_infomation,
    role,
    student_phd_information,
    medical_insurance_postdoc,
  } = user;

  const checkMedical = medical_insurance_postdoc?.filter(
    (e) => e.admin_approve === 1
  );

  const name = `${personal_infomation?.title_name_en} ${
    personal_infomation?.name_en
  } ${personal_infomation?.middle_name_en || ""} ${
    personal_infomation?.surname_en
  }`;

  return (
    <Card>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          container
          md={4}
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{
            paddingTop: "60px",
            paddingBottom: "60px",
            borderRight: "solid 1px rgba(145, 158, 171, 0.24)",
          }}
        >
          <Avatar
            sx={{ width: 150, height: 150 }}
            src={
              personal_infomation?.photo
                ? `${config.host_api}user/photo/${personal_infomation?.photo}`
                : null
            }
          />
          <Typography
            variant="h5"
            component="div"
            style={{ paddingTop: "20px" }}
          >
            {name}
          </Typography>
        </Grid>

        <Grid
          container
          item
          md={8}
          direction="row-reverse"
          justifyContent="center"
          alignItems="center"
        >
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              {role.role === ROLE_MENTOR && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>
                    <Typography variant="subtitle1">Academic Title:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Full Name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Mobile Number:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Number of Postdoc fellow:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Number of PhD students:
                    </Typography>
                  </ListItem>
                </List>
              )}

              {(role.role === ROLE_PHD_5Y || role.role === ROLE_PHD_3Y) && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>
                    <Typography variant="subtitle1">Full name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Start Receiving Scholarship on:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Mobile Number:</Typography>
                  </ListItem>
                </List>
              )}

              {role.role === ROLE_POSTDOC && (
                <List>
                  <ListItem>
                    <Typography variant="subtitle1">Full name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">You Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Start working on:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">End Contract:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Year:</Typography>
                  </ListItem>
                </List>
              )}
            </Grid>

            <Grid item xs={6} md={6}>
              {role.role === ROLE_MENTOR && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.academic_title || "-"}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{name}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{mentor_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{mentor_information?.mobile_number}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{fellow?.number_of_postdoc}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{fellow?.number_of_phd}</Typography>
                  </ListItem>
                </List>
              )}

              {(role.role === ROLE_PHD_5Y || role.role === ROLE_PHD_3Y) && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>{name}</ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{student_phd_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {moment(student_phd_information?.start_reciving).format(
                        "DD/MM/YYYY"
                      )}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {student_phd_information?.mobile_number_th}
                    </Typography>
                  </ListItem>
                </List>
              )}

              {role.role === ROLE_POSTDOC && (
                <List>
                  <ListItem>
                    <Typography>{name}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{postdoctoral_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {moment(postdoctoral_information?.start_reciving).format(
                        "DD/MM/YYYY"
                      )}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>-</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.year_contract}
                    </Typography>
                  </ListItem>
                </List>
              )}
            </Grid>

            {role?.role === ROLE_POSTDOC &&
              personal_infomation?.nationality !== "Thai" && (
                <Grid item xs={6} md={6}>
                  <Item sx={{ minWidth: 500, maxHeight: 120 }}>
                    <CardContent>
                      <Typography variant="h6" component="div">
                        Health Insurance (For Foreign Postdoc):
                      </Typography>
                      {checkMedical?.length === 0 ? (
                        <Stack direction="row" sx={{ paddingTop: 1 }}>
                          <PendingActionsIcon />
                          <Typography
                            sx={{ mb: 1.5, paddingLeft: 1 }}
                            color="text.secondary"
                          >
                            Pending
                          </Typography>
                        </Stack>
                      ) : (
                        <Stack direction="row" sx={{ paddingTop: 1 }}>
                          <VerifiedIcon sx={{ color: "#1CD1A1" }} />
                          <Typography
                            sx={{ mb: 1.5, paddingLeft: 1 }}
                            color="text.secondary"
                          >
                            Verified
                          </Typography>
                        </Stack>
                      )}
                    </CardContent>
                  </Item>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

const CurrentProfile = (user) => {
  const {
    email,
    fellow,
    personal_infomation,
    postdoc_educational_background,
    postdoctoral_information,
    student_phd_information,
    working_experience,
    medical_insurance_postdoc,
    mentor_information,
    role,
  } = user;

  const checkMedical = medical_insurance_postdoc?.filter(
    (e) => e.admin_approve === 1
  );
  const navigate = useNavigate();

  const linkToEdit = () => {
    switch(role?.role){
      //case ROLE_ADMIN: navigate("/profile/admin/edit");break;
      case ROLE_MENTOR: navigate("/profile/mentor/edit");break;
      case ROLE_POSTDOC: navigate("/profile/post_doc/edit");break;
      default :navigate("/profile/phd/edit");
    }
  };

  return (
    <Card>
      <Grid container direction="row" spacing={2}>
      {role?.role != ROLE_ADMIN && ( 
        <Grid
          item
          container
          md={4}
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{
            paddingTop: "60px",
            borderRight: "solid 1px rgba(145, 158, 171, 0.24)",
          }}
        >
          <Avatar
            src={
              personal_infomation?.photo
                ? `${config.host_api}user/photo/${personal_infomation?.photo}`
                : null
            }
            sx={{ width: 150, height: 150 }}
          />
          <Typography
            variant="h5"
            component="div"
            style={{ paddingTop: "20px" }}
          >
            {personal_infomation?.name_en} {personal_infomation?.surname_en}
          </Typography>
          
          <Box sx={{ paddingTop: "45px", paddingBottom: 5 }} onClick={linkToEdit}>
            <Button variant="outlined">
              Edit Profile
            </Button>
          </Box>
          
        </Grid>
        )}
        <Grid
          container
          item
          md={8}
          direction="row-reverse"
          justifyContent="center"
          alignItems="center"
        >
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              {role?.role === ROLE_POSTDOC && (
                <List>
                  <ListItem>
                    <Typography variant="subtitle1">Full name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">You Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Start working on:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">End Contract:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Year:</Typography>
                  </ListItem>
                </List>
              )}

              {(role?.role === ROLE_PHD_5Y || role?.role === ROLE_PHD_3Y) && (
                <List sx={{ paddingTop: 6 }}>
                  <ListItem>
                    <Typography variant="subtitle1">Full name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Start Receiving Scholarship on:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Mobile Number:</Typography>
                  </ListItem>
                </List>
              )}

              {role?.role === ROLE_MENTOR && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>
                    <Typography variant="subtitle1">Academic Title:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Full Name:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Email:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Faculty:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">Mobile Number:</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Number of Postdoc fellow:
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="subtitle1">
                      Number of PhD students:
                    </Typography>
                  </ListItem>
                </List>
              )}

              {/* {role?.role === ROLE_ADMIN && (
                <List>
                  <ListItem>
                    <Typography variant="subtitle1">Full Name:</Typography>
                  </ListItem>

                  <ListItem>
                    <Typography variant="subtitle1">Email:</Typography>
                  </ListItem>

                  <ListItem>
                    <Typography variant="subtitle1">Mobile Number:</Typography>
                  </ListItem>
                </List>
              )} */}
            </Grid>

            <Grid item xs={6} md={6}>
              {role?.role === ROLE_POSTDOC && (
                <List>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.name_en}{" "}
                      {personal_infomation?.surname_en}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{postdoctoral_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {moment(postdoctoral_information?.start_reciving).format(
                        "d/m/y"
                      )}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {moment(postdoctoral_information?.contract_end).format(
                        "d/m/y"
                      )}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.year_contract}
                    </Typography>
                  </ListItem>
                </List>
              )}

              {(role?.role === ROLE_PHD_5Y || role?.role === ROLE_PHD_3Y) && (
                <List sx={{ paddingTop: 6 }}>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.name_en}{" "}
                      {personal_infomation?.surname_en}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{student_phd_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {moment(postdoctoral_information?.start_reciving).format(
                        "d/m/y"
                      )}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {student_phd_information?.mobile_number_th}
                    </Typography>
                  </ListItem>
                </List>
              )}

              {role?.role === ROLE_MENTOR && (
                <List sx={{ paddingTop: 3 }}>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.academic_title !== ""
                        ? personal_infomation?.academic_title
                        : "-"}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>
                      {personal_infomation?.name_en}{" "}
                      {personal_infomation?.surname_en}
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{email}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{mentor_information?.faculty}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{mentor_information?.mobile_number}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{fellow.number_of_postdoc}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>{fellow.number_of_phd}</Typography>
                  </ListItem>
                </List>
              )}

              {/* {role?.role === ROLE_ADMIN && (
                <List>
                  <ListItem>
                    <Typography>-</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>-</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography>-</Typography>
                  </ListItem>
                </List>
              )} */}
            </Grid>

            {role?.role === ROLE_POSTDOC &&
              personal_infomation?.nationality !== "Thai" && (
                <Grid item xs={6} md={6}>
                  <Item sx={{ minWidth: 500, maxHeight: 120 }}>
                    <CardContent>
                      <Typography variant="h6" component="div">
                        Health Insurance (For Foreign Postdoc):
                      </Typography>
                      {checkMedical.length === 0 ? (
                        <Stack direction="row" sx={{ paddingTop: 1 }}>
                          <PendingActionsIcon />
                          <Typography
                            sx={{ mb: 1.5, paddingLeft: 1 }}
                            color="text.secondary"
                          >
                            Pending
                          </Typography>
                        </Stack>
                      ) : (
                        <Stack direction="row" sx={{ paddingTop: 1 }}>
                          <VerifiedIcon sx={{ color: "#1CD1A1" }} />
                          <Typography
                            sx={{ mb: 1.5, paddingLeft: 1 }}
                            color="text.secondary"
                          >
                            Verified
                          </Typography>
                        </Stack>
                      )}
                    </CardContent>
                  </Item>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default function ProfileView({ user, anotherUser }) {
  return <>{user ? CurrentProfile(user) : AnotherProfile(anotherUser)}</>;
}
